export default __webpack_public_path__ + "static/media/3.de19b88d.svg";